import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { faPlane } from "@fortawesome/free-solid-svg-icons/faPlane";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { add, format, sub } from "date-fns";
import { selectConfig } from "../../config/ConfigSlice";
import { faPlaneSlash } from "@fortawesome/free-solid-svg-icons/faPlaneSlash";
import { useTranslation } from "react-i18next";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons/faArrowRight";
import { fetchResults } from "../SearchFlightsActions";
import { changeDates, selectSearchFlightsForm } from "../searchFlightsSlice";
import { generateDateRange } from "../utils";
import { getLocale } from "../../../utils";

function SearchFlightsResultRange({ frequency, effectiveFrom, effectiveTo, dateMin, dateMax, density }) {
  const dispatch = useAppDispatch();
  const config = useAppSelector(selectConfig);
  const form = useAppSelector(selectSearchFlightsForm);
  const { t } = useTranslation();
  const locale = getLocale(config.app.language);

  const [dates, setDates] = useState([]);

  useEffect(() => {
    if ((form.dateRange || form.dateRangeWeekly) && frequency) {
      setDates(generateDateRange(effectiveFrom, effectiveTo, dateMin, dateMax, frequency));
    } else {
      setDates([]);
    }
  }, [frequency, dateMin, dateMax, form.dateRange, form.dateRangeWeekly]);

  if (dates.length === 0) {
    return null;
  }

  if (density === "compact") {
    return (
      <div className="columns is-mobile has-text-centered flight-result-weekly">
        <div className="column is-narrow is-hidden-mobile">
          <span>{t("DAYS")}: </span>
        </div>
        <div className="column">
          <div className="tags">
            {dates.map((date, i) => {
              return (
                <div
                  key={i}
                  className={`tag${date.scheduled ? " is-primary" : ""}`}
                >
                  {config.components.Results.gridHeadDateFormat[0] &&
                    format(
                      date.date,
                      config.components.Results.gridHeadDateFormat[0],
                      { locale }
                    )}
                  &nbsp;
                  {config.components.Results.gridHeadDateFormat[1] &&
                    format(
                      date.date,
                      config.components.Results.gridHeadDateFormat[1],
                      { locale }
                    )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="columns is-mobile is-gapless is-vcentered">
      <div className="column has-text-left">
        <button
          className="button is-small"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(
              changeDates({
                departingDate: sub(form.departingDate, { days: 7 }).getTime(),
                returningDate: sub(form.returningDate, { days: 7 }).getTime(),
              })
            );
            dispatch(
              fetchResults({ queryTrigger: "form_submission" })
            );
          }}
        >
          <span className="icon is-small">
            <FontAwesomeIcon icon={faArrowLeft} />
          </span>
        </button>
      </div>
      {dates.map((date, i) => {
          const isArabic = locale?.code === "ar-SA";
        const dateFormat = isArabic ? "EEEE" : config.components.Results.gridHeadDateFormat[0];

          return (
              <div key={i} className="column has-text-centered">
                  <div
                      className={`is-size-7${date.scheduled ? "" : " has-text-grey-light"}`}
                      title={
                          date.scheduled
                              ? `${t("TITLE_DAY_OF_OP")} ${format(date.date, "EEEE dd MMM yyyy", { locale })}`
                              : ""
                      }
                  >
                      {dateFormat &&
                          format(
                              date.date,
                              dateFormat,
                              { locale }
                          )}
                      <br />
                      {config.components.Results.gridHeadDateFormat[1] &&
                          format(
                              date.date,
                              config.components.Results.gridHeadDateFormat[1],
                              { locale }
                          )}
                  </div>
            <FontAwesomeIcon
              icon={date.scheduled ? faPlane : faPlaneSlash}
              fixedWidth
              color={date.scheduled ? null : "lightGrey"}
              title={
                date.scheduled
                  ? `${t("TITLE_DAY_OF_OP")}${format(
                      date.date,
                        isArabic ? "EEEE dd MMM yyyy" : "EEE dd MMM yyyy",
                      {
                        locale,
                      }
                    )}`
                  : ""
              }
            />
          </div>
        );
      })}
      <div className="column has-text-right">
        <button
          className="button is-small"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(
              changeDates({
                departingDate: add(form.departingDate, { days: 7 }).getTime(),
                returningDate: add(form.returningDate, { days: 7 }).getTime(),
              })
            );
            dispatch(
              fetchResults({ queryTrigger: "form_submission" })
            );
          }}
        >
          <span className="icon is-small">
            <FontAwesomeIcon icon={faArrowRight} />
          </span>
        </button>
      </div>
    </div>
  );
}

function getUTCStringDate(scheduled) {
  const date = new Date(scheduled);
  return format(date, "EEE dd MMM yyyy");
}

export default SearchFlightsResultRange;
